import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import {
  Box,
} from "@material-ui/core";
import HubbleContainer from "@jumbo/Dashboards/HubbleContainer";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.hubble"} />, isActive: true },
];

const Hubble = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.hubble" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box marginBottom={"10px"}>
            <div>
              <IntlMessages id="pages.hubble.description" />
            </div>
          </Box>

          <Divider />
          <div style={{ marginTop: 24 }}>
            <HubbleContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Hubble;
